import { render, staticRenderFns } from "./UnreadReferralMessages.vue?vue&type=template&id=f47f3486"
import script from "./UnreadReferralMessages.vue?vue&type=script&lang=js"
export * from "./UnreadReferralMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports